// cleanup_convert_to_typescript_file_PYMTCNTR

import React from 'react';

import AddWidget from 'components/addWidget/AddWidget';
import PageHeader from 'components/pageHeader/PageHeader';
import Workspace from 'components/workspace/Workspace';
import useLocale from 'components/useLocale';
import DeviceViewSwitcher from 'components/deviceViewSwitcher/DeviceViewSwitcher';
import PaymentsNative from 'components/widgets/payments/native/Payments';

const PaymentsWorkspaceComponent = () => {
  const locale = useLocale();
  return (
    <>
      <PageHeader fdicLogoWeb title={locale['common.paymentCenter']}>
        <div>
          <AddWidget workspaceId="PYMTCNTR" />
        </div>
      </PageHeader>
      <DeviceViewSwitcher flat>
        <Workspace
          type="web"
          workspaceId="PYMTCNTR"
          workspaceName={locale['common.paymentCenter']}
        />
        <PaymentsNative type="native" />
      </DeviceViewSwitcher>
    </>
  );
};

export default PaymentsWorkspaceComponent;
